import modelRequest, { RequestError } from './lib/modelRequest'

/**
 * Donuts response
 */
export interface DonutReadingResponse {
  phonics: { total: number; completed: number }
  alphabet: { total: number; completed: number }
  phrases: { total: number; completed: number }
  stories: {
    total: number
    completed: number
    instructionalLevelProbe: number
    weeks: number
    years: number
    wpmPercentChange: number
  },
  valid: true
}

export interface DonutMathResponse {
  addition: { total: number; completed: number }
  subtraction: { total: number; completed: number }
  multiplication: { total: number; completed: number }
  division: { total: number; completed: number }
  valid: true
}

interface Suggested {
  suggestedPhonicsType: string,
  suggestedStory: string
}

export default {
  /**
   * Gets donut information
   */
  getReadingProgress: (variables: {
    studentID?: string
  }): Promise<DonutReadingResponse | RequestError> => {
    return modelRequest.get('/api/donuts', { params: { ...variables, program: "reading" } })
  },

  getMathProgress: (variables: {
    studentID?: string
  }): Promise<DonutMathResponse | RequestError> => {
    return modelRequest.get('/api/donuts', { params: { ...variables, program: "math" } })
  },

  getPhonicsType: (variables:{
    studentID?: string
  }): Promise<Suggested | RequestError> => {
      return modelRequest.get('/api/suggested', { params: {...variables} })
  },
}
